import * as CryptoJS from 'crypto-js';

const encryptionKey = CryptoJS.enc.Hex.parse('603deb1015ca71be2b73aef0857d77811f352c073b6108d72d9810a30914dff4');

export const encrypt = (data: object): string => {
  const dataString: string = JSON.stringify(data);
  const ciphertext = CryptoJS.AES.encrypt(dataString, encryptionKey, { mode: CryptoJS.mode.ECB }).toString();
  return ciphertext;
};